import Nullstack from 'nullstack';
export default function IconBattery4({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-battery-4",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 7h11a2 2 0 0 1 2 2v.5a0.5 .5 0 0 0 .5 .5a0.5 .5 0 0 1 .5 .5v3a0.5 .5 0 0 1 -.5 .5a0.5 .5 0 0 0 -.5 .5v.5a2 2 0 0 1 -2 2h-11a2 2 0 0 1 -2 -2v-6a2 2 0 0 1 2 -2"
  }), "   ", Nullstack.element("line", {
    x1: "7",
    y1: "10",
    x2: "7",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "10",
    y1: "10",
    x2: "10",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "13",
    y1: "10",
    x2: "13",
    y2: "14"
  }), "   ", Nullstack.element("line", {
    x1: "16",
    y1: "10",
    x2: "16",
    y2: "14"
  }), " ");
}